import { Box, Divider, Tab, Tabs, Typography } from "@mui/material"
import { ChevronRightOutlined, FilterAltOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useState } from "react"

import { OPPORTUNITY_PIPELINE_TAB } from "../constants"

import { NewRequestDialog } from "./NewRequestDialog/NewRequestDialog"

import { Button } from "@/components/common/Button"
import SearchInput from "@/components/SearchInput/SearchInput"

export const SalesPage: FC = () => {
  const [isNewRequestOpen, setIsNewRequestOpen] = useState(false)

  const handleNewRequestOpen = () => setIsNewRequestOpen(true)
  const handleNewRequestClose = () => setIsNewRequestOpen(false)

  return (
    <Box className='flex h-full flex-col gap-y-4'>
      <Typography variant='h5' className='font-normal text-gray-900'>
        Sales Pipeline
      </Typography>

      <Box>
        <Tabs value={OPPORTUNITY_PIPELINE_TAB}>
          <Tab label='Opportunity Pipeline' value={OPPORTUNITY_PIPELINE_TAB} />
        </Tabs>
        <Divider />
      </Box>

      <Box className='flex items-center gap-x-3'>
        <SearchInput
          placeholder='Search by Company Name, ID'
          className='w-full max-w-[400px]'
          data-testid='sales.page.search-field'
        />
        <Button appearance='outlined' startIcon={<FilterAltOutlined />} data-testid='sales.page.filter-button'>
          Filter
        </Button>
        <Box className='flex-1' />
        <Button
          appearance='contained'
          endIcon={<ChevronRightOutlined />}
          onClick={handleNewRequestOpen}
          data-testid='sales.page.start-request-button'
        >
          Start Request
        </Button>
      </Box>

      {isNewRequestOpen && <NewRequestDialog onClose={handleNewRequestClose} />}
    </Box>
  )
}
